import React, { useState } from 'react';
import '../styles/UsersPanel.css';
import { Button } from '../components';
import { Chevron, Copy, TickHeavy } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';
import { format, fromUnixTime } from 'date-fns';

function UsersPanel(props) {
    const company = props.company;
    const users = company.users;
    const closeUsersPanel = props.closeUsersPanel;
    const setDeleteUserObject = props.setDeleteUserObject;
    const setShowDeleteUserModal = props.setShowDeleteUserModal;
    const setNewUserModal = props.setNewUserModal;
    const backDisabled = props.backDisabled;
    const [companyIdCopied, setCompanyIdCopied] = useState(false);

    const headings = [
        {
            preIcon: null,
            label: "User",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Email",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Date joined",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Role",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Actions",
            postIcon: null
        }
    ];

    const showNewUser = () => {
        setNewUserModal(true);
    };
    
    const deleteUser = (item) => {
        setDeleteUserObject(item);
        setShowDeleteUserModal(true);
    };

    const copyCompanyId = () => {
        navigator.clipboard.writeText(company.companyId);
        setCompanyIdCopied(true);
    };

    return (
        <div className="users-panel-container">
            <div className="users-panel-close-container">
                <div 
                    className="text-button button-row gap-x-small"
                    onClick={() => backDisabled === true ? null : closeUsersPanel()}
                >
                    <Chevron
                        fill={colour.gray06}
                        className="reverse"
                    />
                    <span className="body-regular colour-primary">
                        Back
                    </span>
                </div>
            </div>
            <div className="users-panel-inner-container">
                <div className="users-panel-title-container">
                    <h2 className="heading-large-bold colour-primary">
                        Users
                    </h2>
                </div>
                <div className="users-panel-top-container">
                    <div className="users-panel-top-left-container">
                        <div className="users-panel-top-left-element">
                            <span className="body-regular colour-primary">
                                Company
                            </span>
                            <span className="body-bold colour-primary">
                                {company.companyName}
                            </span>
                        </div>
                        <div className="users-panel-top-left-element">
                            <span className="body-regular colour-primary">
                                Total users
                            </span>
                            <span className="body-bold colour-primary">
                                {users.length}
                            </span>
                        </div>
                        <div className="users-panel-top-left-element">
                            <div className="users-panel-top-left-inner-element">
                                <span className="body-regular colour-primary">
                                    Company ID
                                </span>
                                <div 
                                    className="users-panel-copy-container"
                                    onClick={() => copyCompanyId()}
                                >
                                    {
                                        companyIdCopied === true ?
                                        <TickHeavy fill={colour.gray06} className="cursor-pointer" />
                                        :
                                        <Copy fill={colour.gray06} className="cursor-pointer" />
                                    }
                                </div>
                            </div>
                            <div>
                                <span className="body-bold colour-primary">
                                    {company.companyId}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="users-panel-top-right-container">
                        <Button
                            buttonType="primary-button"
                            size="large"
                            text={"New user"}
                            cta={() => showNewUser()}
                            disabled={false}
                            leftIcon={null}
                            leftIconClass=""
                            rightIcon={null}
                            rightIconClass=""
                            alt=""
                            standardIcon={true}
                            badge={false}
                            badgeVal={null}
                            badgeBG={null}
                            buttonRef={null}
                            spinner={false}
                        />
                    </div>
                </div>
                <table className="users-panel-table-container">
                    <thead className="">
                        <tr className="bg-colour-white">
                            {
                                headings.map((item, index) =>
                                    <th 
                                        className="users-panel-label-element"
                                        key={index}
                                    >
                                        <span className="body-regular colour-secondary">
                                            {item.label}
                                        </span>
                                    </th>
                                )
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            users.map((item, index) =>
                                <tr 
                                    key={index}
                                    className=""
                                >
                                    <td className="users-panel-value-element">
                                        <span className="body-regular colour-primary">
                                            {item.firstName} {item.lastName}
                                        </span>
                                    </td>
                                    <td className="users-panel-value-element">
                                        <span className="body-regular colour-primary">
                                            {item.email}
                                        </span>
                                    </td>
                                     <td className="users-panel-value-element">
                                        <span className="body-regular colour-primary">
                                            {format(fromUnixTime(item.date["_seconds"]), "MMM dd, yyyy")}
                                        </span>
                                    </td>
                                    <td className="users-panel-value-element">
                                        <span className="body-regular colour-primary">
                                            {
                                                item.admin === true ?
                                                "Admin"
                                                :
                                                "User"
                                            }
                                        </span>
                                    </td>
                                    <td className="users-panel-value-element">
                                        <Button
                                            buttonType="destructive-button"
                                            size="x-small"
                                            text={"Delete"}
                                            cta={() => deleteUser(item)}
                                            disabled={false}
                                            leftIcon={null}
                                            leftIconClass=""
                                            rightIcon={null}
                                            rightIconClass=""
                                            alt=""
                                            standardIcon={true}
                                            badge={false}
                                            badgeVal={null}
                                            badgeBG={null}
                                            buttonRef={null}
                                            spinner={false}
                                        />
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
};

export default UsersPanel;